import { createApp } from 'vue'
import App from './App.vue'
import router from './routes'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || "https://rcckitportal.sun-rack.com/api/";
// axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || "http://127.0.0.1:8000/api/";
axios.defaults.withCredentials = true  // important for session

const app = createApp(App)
app.use(router)
app.config.globalProperties.$axios = axios
app.mount('#app')

window.WebSocket = window.WebSocket || function () {
  console.warn("WebSocket not available.");
};
